import * as React from 'react';
// Import the mapbox gl stylesheet
// tslint:disable-next-line:no-submodule-imports
import '../../../../../../node_modules/mapbox-gl/dist/mapbox-gl.css';
import LoadingSpinner from '../../../LoadingSpinner';
import withLazyLoader from '../../../withLazyLoader';
import { ActivityMapContainerProps } from '../../types';
import './ActivityMap.scss';

/** Placeholder for the map and chart while the code is dynamically loading */
export const LazyActivityMapPlaceholder = () => (
    <>
        <div className="activity-map-container">
            <LoadingSpinner className="map-loader" />
        </div>
    </>
);

/**
 * Returns a promise which lazy loads the activity map component
 */
export const preloadActivityMap = async (): Promise<
    React.ComponentClass<any> | React.StatelessComponent<any>
> => {
    const component = await import(/* webpackChunkName: "activity_map" */ './ActivityMapContainer');
    return component.default as
        | React.ComponentClass<any>
        | React.StatelessComponent<any>;
};

/** Use withProps to inject the preloading function into the lazy load component */
const LazyActivityMap = withLazyLoader<ActivityMapContainerProps>(
    {
        lazyLoadComponent: preloadActivityMap
    },
    LazyActivityMapPlaceholder
);

export default LazyActivityMap;



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/ActivityMap/LazyActivityMap.tsx